export class GetIngestionPipelineErrorsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "errorClasses",
            "baseName": "errorClasses",
            "type": "Array<IngestionPipelineErrorClass>",
            "format": ""
        },
        {
            "name": "windowSeconds",
            "baseName": "windowSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "asOf",
            "baseName": "asOf",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GetIngestionPipelineErrorsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
